import './event-country-and-regional-card.html.twig';
import './event-country-and-regional-card.scss';

export default function () {
  const cards = document.querySelectorAll('.event-country-regional-card');

  if (!cards) {
    return;
  }

  cards.forEach((card) => {
    const link = card.querySelector('.event-country-regional-card__link > a');
    card.addEventListener('click', () => {
      link.click();
    });
  });
}
